import { render, staticRenderFns } from "./LogoClassy.vue?vue&type=template&id=6bd5763d"
import script from "./LogoClassy.vue?vue&type=script&lang=js"
export * from "./LogoClassy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports